import { getAllStructOutlines } from '@/editor/stores/utils/column';
import { getAllFurnitureOutlines } from '@/editor/stores/utils/furniture';

/**
 * box 标尺的射线参照物：全部柱子 + 家具（移动/选中态要排除自身，新建态不排除）。
 * 柱子自身的标尺只参照柱子，不走这里
 */
export function getBoxRayDetectOutlines(excludeFurnitureIds?: string[]) {
  return [...getAllStructOutlines(), ...getAllFurnitureOutlines(excludeFurnitureIds)];
}
